import { PAGES } from 'common/enums';
import { ROLES_WITH_NO_ACCESS_TO_TASKS_REDIRECT } from '../constants';
import { useTypedSelector } from './use-typed-selector';
import { User } from '../common/interfaces';

const PAGES_TO_REDIRECT = [PAGES.DASHBOARD, PAGES.MY_REQUESTS, PAGES.ACCOUNT_SETTINGS, PAGES.SUPPORT];

export const useRedirectTo = () => {
  const user = useTypedSelector<User>(state => state['app'].user);
  const mainRoleId = user.mainRole?.id as keyof typeof ROLES_WITH_NO_ACCESS_TO_TASKS_REDIRECT;

  const tasksRedirectTo = () => {
    if (user.appPages.some(appPage => appPage.url === ROLES_WITH_NO_ACCESS_TO_TASKS_REDIRECT[mainRoleId])) {
      return ROLES_WITH_NO_ACCESS_TO_TASKS_REDIRECT[mainRoleId];
    }
    const pageToRedirect = PAGES_TO_REDIRECT.find(page => user.appPages.some(appPage => appPage.url === page));

    if (pageToRedirect) {
      return pageToRedirect;
    }

    return user.appPages[0]?.url;
  };

  return { tasksRedirectTo };
};
